<template>
  <WorkBenchWorkPackageInfoBox
    :color="work_package.color"
    :text_color="work_package.textcolor"
    width="450px"
    height="296px"
    >
    <template #button-top v-if="$route.name !== `${location}WorkPackageInfoBoxWorkPackageEditor`">
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.up"
        direction="up"
        width="80px"
        @click.native="
          nav_direction = 'up',
          $router.push({
            name: getWaggonInfoNavigation.up,
            params: {direction: 'up'}
          })
          "
        />
    </template>
    <template #button-right v-if="$route.name !== `${location}WorkPackageInfoBoxWorkPackageEditor`">
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.right"
        direction="right"
        height="80px"
        @click.native="
          nav_direction = 'right',
          $router.push({
            name: getWaggonInfoNavigation.right,
            params: {direction: 'right'}
          })
          "
        />
    </template>
    <template #button-bottom v-if="$route.name !== `${location}WorkPackageInfoBoxWorkPackageEditor`">
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.down"
        direction="down"
        width="80px"
        @click.native="
          nav_direction = 'down',
          $router.push({
            name: getWaggonInfoNavigation.down,
            params: {direction: 'down'}
          })
          "
        />
    </template>
    <template #button-left v-if="$route.name !== `${location}WorkPackageInfoBoxWorkPackageEditor`">
      <WaggonInfoNavButton
        v-if="getWaggonInfoNavigation.left"
        direction="left"
        height="80px"
        @click.native="
          nav_direction = 'left',
          $router.push({
            name: getWaggonInfoNavigation.left,
            params: {direction: 'left'}
          })
          "
        />
    </template>
    <template #content>
      <WorkBenchWorkPackageHeader
        v-if="template_type !== 'swaggonrecommendation'"
        :icon="work_package.icon"
        :text_color="work_package.textcolor"
        >
        <template #text>
          {{work_package.token}} - {{work_package.name}}
        </template>
        <template #actions>
          <v-btn class="mr-1" small
            @click="addWorkPackageToWaggon()"
            >
            add
          </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="template_type === 'custom'"
              class="grey darken-4"
              icon
              small
              v-on="on"
              v-bind="attrs"
              @click="$router.push({
                  name: `${location}WorkPackageInfoBoxWorkPackageEditor`,
                  params: {
                    workpackage_id: work_package.id
                  }
                })"
              >
              <v-icon small style="color: white">
                edit
              </v-icon>
            </v-btn>
          </template>
          <span>{{$t('WorkBench.Editor.Sequence.Workpackage.edit')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="grey darken-4 ml-1"
              icon
              small
              v-on="on"
              v-bind="attrs"
              @click="
              getNestedWorkPackageCreate(work_package, true).then(work_package => {
                updateWBLObject({
                  path: [
                  {workpackage: ''}
                  ],
                  update: work_package
                  }),
                  $router.push({
                    name: `${location}WorkPackageInfoBoxWorkPackageEditor`,
                    params: {
                      workpackage_id: 'create',
                    }
                  })
                })
              "
              >
              <v-icon small style="color: white">
                content_copy
              </v-icon>
            </v-btn>
          </template>
          <span>{{$t('WorkBench.Editor.Sequence.Workpackage.copy')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="grey darken-4 ml-1"
              icon
              small
              v-on="on"
              v-bind="attrs"
              @click="
              getNestedWorkPackageCreate(work_package, false).then(work_package => {
                updateWBLObject({
                  path: [
                  {workpackage: ''}
                  ],
                  update: work_package
                  }),
                  $router.push({
                    name: `${location}WorkPackageInfoBoxWorkPackageEditor`,
                    params: {
                      workpackage_id: 'create',
                    }
                  })
                })
              "
              >
              <v-icon small style="color: white">
                file_copy
              </v-icon>
            </v-btn>
          </template>
          <span>{{$t('WorkBench.Editor.Sequence.Workpackage.copyWithoutSteps')}}</span>
        </v-tooltip>
        </template>
      </WorkBenchWorkPackageHeader>
      <template v-else>
        <StandardFlexBox
          height="30px"
          width="450px"
          align_content="center"
          style="overflow: visible"
          no_wrap="true"
          >
          <WorkBenchWorkPackageHeader
            class="cursor-pointer"
            v-for="(workpackage, index) in waggon.sworkpackages"
            :key="index"
            :icon="workpackage.icon"
            :text_color="workpackage.textcolor"
            :color="workpackage.color"
            :width="index === workpackage_id?`calc(450px - (70px * ${waggon.sworkpackages.length-1})`:'70px'"
            :no_color_picker="true"
            @click.native="index === workpackage_id?'':$router.push({
                name: 'RecommendedWaggonWorkPackageInfo',
                params: {
                  rec_waggon_work_package_index: index
                }
              })"
            >
            <template #text>
              {{workpackage.token}} {{index === workpackage_id?` - ${workpackage.name}`:''}}
            </template>
            <template #actions v-if="index === workpackage_id">
              <v-btn
                class="grey darken-4"
                icon
                small
                style="margin-top: -2px"
                @click="
                getNestedWorkPackageCreate(workpackage, true).then(work_package => {
                  updateWBLObject({
                    path: [
                    {workpackage: ''}
                    ],
                    update: work_package
                    }),
                    $router.push({
                      name: 'RecommendedWaggonWorkPackageEditor',
                      params: {
                        workpackage_id: 'create',
                      }
                    })
                  })
                "
                >
                <v-icon small style="color: white">
                  content_copy
                </v-icon>
              </v-btn>
            </template>
          </WorkBenchWorkPackageHeader>
        </StandardFlexBox>
      </template>
      <transition name="dialog_slide">
        <router-view
          v-if="$route.name.includes('WorkPackageEditor')"
          style="z-index: 20"
          />
      </transition>
      <router-view
        v-if="!$route.name.includes('WorkPackageEditor')"
        style="z-index: 20"
        />
    </template>
  </WorkBenchWorkPackageInfoBox>
</template>
<script>
  import store from '@/store/index';
  import { WorkBenchWorkPackageInfoBoxMixin} from '@/mixins/WorkBenchWorkPackageInfoBox.mixin.js'
  export default {
    props: [
      'sequence_id',
      'waggon_id',
      'workpackage_id',
      'template_type',
      'create',
      'waggon',
      'location'
    ],
    mixins: [
      WorkBenchWorkPackageInfoBoxMixin,
    ],
    data: () => ({
    }),
    created() {
    },
    beforeRouteUpdate: (to, from, next) => {
      if (to.params.workpackage_id === 'create') {
        next();
      } else {
        if (to.params.workpackage_id !== from.params.workpackage_id &&
          to.params.info_box_template_type !== 'recommendation' &&
          to.params.info_box_template_type !== 'swaggonrecommendation'
        ) {
          let prefix = '';
          switch (to.params.info_box_template_type) {
            case 'company':
            prefix = 'b';
            break;
            case 'community':
            prefix = 'c';
            break;
          }
          store.dispatch('WorkBench/requestWBObject', {
            url: [
              {[`${prefix}workpackages`]: to.params.workpackage_id},
              {showWithEntitiesNormalized: ''}
            ]
          }).then(() => next())
        } else {
          next();
        }
      }
    },
    methods: {
      addWorkPackageToWaggon(){
        if ( this.location.includes(`Sequence`) ) {
          // SEQUENCE
          if (this.$route.params.sequence_id === 'create') {
            this.getNestedWorkPackageCreateSequence(this.work_package).then(wp => {
              this.createWBLObject({
                path: [
                  {sequence: ''},
                  {swaggons: this.waggon_id},
                  {sworkpackages: ''},
                ],
                wbl_object: wp
              })
            })
          } else {
            this.createWBObject({
              url: [
                {[`${this.outer_prefix}sequences`]: this.sequence_id},
                {[`${this.outer_prefix}swaggons`]: this.waggon_id},
                {[`${this.outer_prefix}sworkpackages`]: `complete${this.outer_prefix}sworkpackage`},
                {showWithEntitiesNormalized: ''}
              ],
              wb_object: this.template_type === 'recommendation' ? this.work_package : this.getNestedWorkPackageAdd()
            })
          }
        } else {
          // WAGGON
          if (this.create) {
            this.getNestedWorkPackageCreateWaggon(this.work_package).then(wp => {
              this.createWBLObject({
                path: [
                  {waggon: ''},
                  {wagworkpackages: ''},
                ],
                wbl_object: wp
              })
            })
          } else {
            this.createWBObject({
              url: [
                {[`${this.outer_prefix}waggons`]: this.waggon_id},
                {[`${this.outer_prefix}wagworkpackages`]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              wb_object: this.template_type === 'recommendation' ? this.work_package : this.getNestedWorkPackageAddToWaggon()
            })
          }
        }

      }
    }
  }
</script>
<style>
  /* .dialog_slide-enter, .dialog_slide-leave-to {
  transform: translateY(100vh);
  }
  .dialog_slide-enter-active, .dialog_slide-leave-active {
  transition: transform 0.2s ease-in-out;
  } */
</style>
